export async function delay(timeout = 0) {
    await new Promise((resolve)=>setTimeout(resolve, timeout));
}
export async function retryOnError(func, retries = 5, timeoutMs = 500, maxTimeoutMs = timeoutMs * 4) {
    async function retryLoop(currentTry) {
        try {
            return await func();
        } catch (e) {
            if (currentTry >= retries) throw e;
            await delay(Math.min(currentTry * timeoutMs, maxTimeoutMs));
            return retryLoop(currentTry + 1);
        }
    }
    return retryLoop(1);
}
